export default __webpack_public_path__ + "static/media/logo-finanzas.802befe9.svg";